// extracted by mini-css-extract-plugin
module.exports = {"container":"faqs_container__zm9k2","title":"faqs_title__21PUq","question":"faqs_question__39afJ","version":"faqs_version__3wmx-","answer":"faqs_answer__62bmH"};